<template>
    <span>
      <b-tooltip label="Sync to Eclipse"
        position="is-bottom"
      >
        <b-button
          label="Eclipse"
          type="is-primary"
          size="is-small"
          icon-pack="fas"
          icon-left="cloud-upload-alt"
          v-bind:loading="in_progress_one"
          @click="syncPortfolio()"
          outlined
        />
    </b-tooltip>
    <div v-if="success">
      <o-notification class="eclipse_notifications" closable variant='success' aria-close-label='Close' role='alert'>
        {{success}}
      </o-notification>
    </div>
    </div>
    <div v-if="warning">
  <o-notification class="eclipse_notification" closable variant='warning' aria-close-label='Close' role='alert'>
    {{warning}}
  </o-notification>
</div>
<div v-if="error">
  <o-notification class="eclipse_notification" closable variant='danger' aria-close-label='Close' role='alert'>
    {{error}}
  </o-notification>
</div> 

  </span>
</template>

<script>

export default {
    data() { 
      return {
        headers: {},
        interval: false,
        task_id: false,
        in_progress_one: false,
        warning: false,
        error: false,
        success: false
      }
    },
    props: {
        portfolioId: String,
        portfolioName: String
    },
    methods: {
      async syncUpdate() {
        let taskResponse = await fetch(`/api/v1/tasks/${this.task_id}/`);
        let taskData = await taskResponse.json();
        if (taskData.task.status !== 'pending') {
          if (taskData.task.status === 'failed') {
            this.error = "Error syncing portfolio with Eclipse: " + taskData.task?.meta?.error
          }
          else if(taskData.task.status === 'complete') {
            if(taskData?.meta?.error) {
              this.error = "Error: " + taskData?.task?.meta?.error
            }
            else {
              this.success = "Sync with Eclipse successful";
            }
          }
          this.in_progress_one = false
          clearInterval(this.interval)
          this.interval = false
        }
      },
      async syncPortfolio() {
        if(this.interval) {
          this.error = "Still processing"
          return
        }
        this.headers = { 'X-CSRFToken': this.$root.$data.csrfToken}
        const portfolioName = prompt("What do you want to name this portfolio in Orion?", this.portfolioName);
        if (portfolioName === null) {
          return;
        }
        const url = '/api/v1/send_to_orion/';
        const data = await fetch(url, { method: 'POST', headers: { ...this.headers, 'Content-Type': 'application/json' }, body: JSON.stringify({ 'portfolio_id': this.portfolioId, 'portfolio_name': portfolioName }) });
        if (data.status === 200) {
          const j = await data.json()
          if(!j['success']) {
            if(j['error'] == 'Not authenticated') {
              alert('You must first authenticate with Orion');
              location = '/brokerage/orion';
            }
            else {
              this.error ='Error send portfolio to Eclipse: ' + j['error']
            }
          }
          else {
            if(j['warning']) {
              this.warning = "Warning: " + j['warning']
            }
            this.task_id = j['task_id']
            this.in_progress_one = true
            this.interval = setInterval(()=> {
                this.syncUpdate() },500)
          }
        } else {
            this.error = "Error sending to Astro"
        }
        console.log('sendToOrion, data: ', data);

      }
    }
}
</script>
<style>
.eclipse_notification {
  width:300px;
}
</style>